import { ListPageSkeleton } from '@/components/PageSkeleton';
import { Skeleton } from '@/components/ui/skeleton';
import { useUserStore } from '@/stores/userStore';
import { AdAccountStatistics } from './components/AdAccountStatistics';

/** 广告账户代码加载时的占位，保留初始分页并按现有权限预留批量操作位置 */
export function AdAccountSkeleton() {
  const permissionCodes = useUserStore((state) => state.userInfo?.permissionCodes);
  const canBatchAuthorize = permissionCodes?.includes('business:ad_account:authorization');

  return (
    <div className="flex flex-col gap-4" aria-hidden="true">
      <AdAccountStatistics loading />
      <ListPageSkeleton
        columnCount={13}
        showPagination
        contentClassName="gap-2 p-0 pb-4 [&>div:last-child]:px-4"
        filterArea={
          <div className="flex flex-wrap items-center gap-2 px-4 pt-4">
            {/** 账户、平台、状态、开户主体和日期 */}
            <Skeleton className="h-9 w-45" />
            <Skeleton className="h-9 w-45" />
            <Skeleton className="h-9 w-45" />
            <Skeleton className="h-9 w-45" />
            <Skeleton className="h-9 w-65" />
            <div className="ml-auto flex items-center gap-2">
              <Skeleton className="h-9 w-20" />
              <Skeleton className="h-9 w-20" />
              {/** 批量入口沿用页面权限，减少代码加载完成后的工具栏宽度变化 */}
              {canBatchAuthorize && <Skeleton className="h-9 w-20" />}
              {/** 列配置入口 */}
              <Skeleton className="h-9 w-24 shrink-0" />
            </div>
          </div>
        }
      />
    </div>
  );
}
